/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Directive, ElementRef, EventEmitter, HostListener, Input, Output} from '@angular/core';
export class OutsideClick {
/**
 * @param {?} el
 */
constructor(private el: ElementRef) {}

     strict = false;

     outsideClick = new EventEmitter<any>(false);
/**
 * @param {?} event
 * @return {?}
 */
documentClick(event: MouseEvent) {
        const /** @type {?} */ target = event.target;         // Get the element in the DOM on which the mouse was clicked
        const /** @type {?} */ host = this.el.nativeElement;  // Get the current actionMenu native HTML element

        if (target === host) {
            return;
        }
        if (!this.strict && host.contains(target)) {
            return;
        }
        this.outsideClick.emit(event);
    }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{selector: "[clrOutsideClick]"}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'strict': [{ type: Input, args: ["clrStrict", ] },],
'outsideClick': [{ type: Output, args: ["clrOutsideClick", ] },],
'documentClick': [{ type: HostListener, args: ["document:click", ["$event"], ] },],
};
}

function OutsideClick_tsickle_Closure_declarations() {
/** @type {?} */
OutsideClick.decorators;
/**
 * @nocollapse
 * @type {?}
 */
OutsideClick.ctorParameters;
/** @type {?} */
OutsideClick.propDecorators;
/** @type {?} */
OutsideClick.prototype.strict;
/** @type {?} */
OutsideClick.prototype.outsideClick;
/** @type {?} */
OutsideClick.prototype.el;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
